var _defs, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureStorage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a40",
    x1: 9,
    y1: 15.834,
    x2: 9,
    y2: 5.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#4093e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#5ea0ef"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 5.788h17v9.478a.568.568 0 01-.568.568H1.068a.568.568 0 01-.568-.568V5.788z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.071 2.166h15.858a.568.568 0 01.568.568v3.054H.5V2.734a.568.568 0 01.571-.568z",
    fill: "#0078d4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.304,
    y: 7.121,
    width: 3.65,
    height: 1.85,
    rx: 0.283,
    fill: "#fff",
    opacity: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 7.095,
    width: 3.65,
    height: 1.85,
    rx: 0.283,
    fill: "#fff",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.096,
    y: 7.095,
    width: 3.65,
    height: 1.85,
    rx: 0.283,
    fill: "#fff",
    opacity: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.358,
    y: 9.767,
    width: 3.65,
    height: 1.85,
    rx: 0.283,
    fill: "#fff",
    opacity: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 7.254,
    y: 9.741,
    width: 3.65,
    height: 1.85,
    rx: 0.283,
    fill: "#ffd400"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.15,
    y: 9.741,
    width: 3.65,
    height: 1.85,
    rx: 0.283,
    fill: "#ffd400"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.358,
    y: 12.439,
    width: 3.65,
    height: 1.85,
    rx: 0.283,
    fill: "#ffd400"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.254,
    y: 12.413,
    width: 3.65,
    height: 1.85,
    rx: 0.283,
    fill: "#ffd400"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12.15,
    y: 12.413,
    width: 3.65,
    height: 1.85,
    rx: 0.283,
    fill: "#ffd400"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureStorage);
export default __webpack_public_path__ + "static/media/azure-storage.c0e3f194aeb39f63e031fd24c8d4dffa.svg";
export { ForwardRef as ReactComponent };